export const activityData = [
  { val: "1", code: "AEP" },
  { val: "2", code: "BAM" },
  { val: "3", code: "BTP" },
  { val: "4", code: "COM" },
  { val: "5", code: "ENV" },
  { val: "6", code: "EXF" },
  { val: "7", code: "HER" },
  { val: "8", code: "IND" },
  { val: "9", code: "JEL" },
  { val: "10", code: "MIS" },
  { val: "11", code: "PET" },
  { val: "12", code: "PPT" },
  { val: "13", code: "PRJ" },
  { val: "14", code: "SEM" },
  { val: "15", code: "SER" },
  { val: "16", code: "TEL" },
  { val: "17", code: "TEN" },
  { val: "18", code: "AUT" },
];

export const bankOptions = [
  {
    value: "30005",
    label: "Mutuelle Congolaise de Crédit",
  },
  {
    value: "30008",
    label: "BGFI",
  },
  {
    value: "30011",
    label: "Crédit Du Congo",
  },
  {
    value: "30012",
    label: "La Congolaise des Banques",
  },
  {
    value: "30013",
    label: "Banque Commerciale Internationale",
  },
  {
    value: "30014",
    label: "Ecobank",
  },
  {
    value: "30015",
    label: "Banque Congolaise de l'Habitat",
  },
  {
    value: "30016",
    label: "United Banque of Africa",
  },
  {
    value: "30018",
    label: "Société Générale du Congo",
  },
  {
    value: "30019",
    label: "Banque Postale du congo",
  },
  {
    value: "30020",
    label: "Banque Sino Congolaise pour l'Afrique",
  },
];

export const PORTAL = "/fosa";
export const SIGN_UP = "/portal/signup";
export const POLICY_HOLDER = "/portal/policyholder";
export const POLICY_HOLDER_SUCCESS = "/portal/policyholder/success";
export const SIGN_UP_SUCCESS = "/portal/signupsuccess";
export const SIGN_UP_FAILED = "/portal/signupfailed";
export const FORGOT_PASSWORD = "/fosa/forgotPassword";
export const SET_PASSWORD = "/fosa/set_password";
export const RESET_SUCCESS = "/fosa/resetSuccess";
export const RESET_FAILURE = "/fosa/resetFailure";
export const PORTAL_INSUREE = "/portal/insuree";
export const PORTAL_CONTRACT = "/portal/contract";
export const FOSA_PORTAL = "/portal/fosaPortal";
export const HOME_PAGE = "/fosa/home";
export const POLICYHOLDER_DETAILS = "/portal/policyholderdetails";
export const PAYMENT_PORTAL = "/portal/payment";
export const PAYMENT_PORTAL_FORM = "/portal/paymentform";
export const FOSA_VERIFICATION = "/fosa/verification";
export const HEALTH_FACILITY = "/fosa/healthfacility";
export const CLAIM_PORTAL = "/fosa/claim";
export const CLAIM_FORM = "/fosa/claimForm";
export const CLAIM_FORM_BY_ID = "/fosa/claimForm";
export const STAFF_MANAGEMENT = "/fosa/staffmanagement";
export const Pre_Autharization = "/fosa/preautharization";
export const Pre_Autharization_Form = "/fosa/preautharizationForm";
export const Pre_Autharization_FormByid = "/fosa/preautharizationForm";
export const ADMIN_USERS = "/fosa/adminUsers";
export const ADMIN_USER_FORM = "/fosa/adminUsersForm";
export const ADMIN_USER_FORM_BY_ID = "/fosa/adminUsersForm";
export const MEDICAL_ITEMS = "/fosa/healthfacility/medicalItems";
export const MEDICAL_SERVICES = "/fosa/healthfacility/medicalServices";
export const INVOICE_URL = "/fosa/invoices";
export const INVOICE_CREATE_URL = "/fosa/invoices/create";
export const VERIFY_USER_AND_UPDATE_PASSWORD = "/fosa/verify-user-and-update-password";
export const MEDICAL_STAFF_DESIGNATION = [
  "doctor",
  "nurse",
  "consultant",
  "gynecologist",
  "pediatrician",
  "pediatric_surgeon_orthopedist",
  "urologist",
  "ent_specialist",
  "ophtalmologist",
  "stomatologist",
  "pneumologist",
  "cardiologist",
  "endocrinologist",
  "neurologist",
  "nephrologist",
  "infectiologist",
  "clinical_hematologist",
  "reanimator_and_emergency_physician",
  "medical_biologist",
  "radiologist",
  "dermatologist",
  "general_practitioner",
  "midwife",
  "nurse",
  "laboratory_technician",
  "physiotherapist",
  "anesthesiologist",
  "pharmacist",
  "sanitary_assistant",
  "caregiver",
  "other",
];

export const GedToken = localStorage.getItem("GED_token");

export const idleTimeSet = 30 * 60 * 1000;

export const MENU_FEUILLE_DE_SOINS = "Feuilles de soins";
export const MENU_DEMANDE_DE_PAIEMENT = "Demande de paiement";
export const MENU_GESTION_DU_PROFESSIONNEL_DE_SOINS =
  "Gestion du personnel de soins";
export const MENU_VERIFICATION_DES_ASSURES = "Vérification des assurés";
export const MENU_GESTION_DES_ACCORDS_PREALABLES =
  "Gestion des accords préalables";
export const MENU_ADMINISTRATEUR = "Administrateur";

export const FOSA_ROLES_ALLOWED = [
  MENU_DEMANDE_DE_PAIEMENT,
  MENU_FEUILLE_DE_SOINS,
  MENU_GESTION_DU_PROFESSIONNEL_DE_SOINS,
  MENU_VERIFICATION_DES_ASSURES,
  MENU_GESTION_DES_ACCORDS_PREALABLES,
  MENU_ADMINISTRATEUR,
];

export const DEFAULT_FOSA_USER_PERMISSION = "FOSA Super Admin";

export const PATH_NAME_PERMISSIONS = [
  {
    permission: MENU_DEMANDE_DE_PAIEMENT,
    paths: [
      PAYMENT_PORTAL,
      PAYMENT_PORTAL_FORM,
      INVOICE_URL,
      INVOICE_CREATE_URL,
    ],
  },
  {
    permission: MENU_FEUILLE_DE_SOINS,
    paths: [CLAIM_PORTAL, CLAIM_FORM, CLAIM_FORM_BY_ID],
  },
  {
    permission: MENU_GESTION_DU_PROFESSIONNEL_DE_SOINS,
    paths: [STAFF_MANAGEMENT],
  },
  {
    permission: MENU_VERIFICATION_DES_ASSURES,
    paths: [FOSA_VERIFICATION],
  },
  {
    permission: MENU_GESTION_DES_ACCORDS_PREALABLES,
    paths: [
      Pre_Autharization,
      Pre_Autharization_Form,
      Pre_Autharization_FormByid,
    ],
  },
  {
    permission: MENU_ADMINISTRATEUR,
    paths: [ADMIN_USERS, ADMIN_USER_FORM, ADMIN_USER_FORM_BY_ID],
  },
];

export const HAS_PERMISSION_TO_VIEW_PAGE = (
  permissionsPath,
  currentPath,
  usersPermissions
) => {
  const permissionIndex = permissionsPath.findIndex((p) =>
    p.paths.includes(currentPath)
  );

  if (
    permissionIndex === -1 ||
    usersPermissions?.findIndex((r) => r.name === MENU_ADMINISTRATEUR) > -1
  )
    return true;

  const roles = usersPermissions?.map((r) => r.name) || [];

  if (
    permissionsPath[permissionIndex].paths.includes(currentPath) &&
    roles.includes(permissionsPath[permissionIndex].permission)
  ) {
    return true;
  }

  return false;
};
